import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { ConnectedPayroll } from "../../../Component/Model/Dto/Payroll/Payroll";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { IDropDownOptions } from "../../../Component/Common/Components/FormValidationInputs/AppSelectList";

interface ConnectedPayrollRows {
    payrollName: string;
    payrollType: string;
    payrollUrl: string;
    authenticationType: string;
    actions: ActionType[];
}

interface ConnectedPayrollTable {
    columns: Array<TableColumn>;
    rows: Array<ConnectedPayrollRows>;
}

export function ConnectedPayrollTableMapper(dataObject: ConnectedPayroll[], handleView: (id: string) => void, payrollTypes: IDropDownOptions[], authTypes: IDropDownOptions[]): ConnectedPayrollTable {
    function getActionsColumn(item: ConnectedPayroll, index: number) {
        const actions: ActionType[] = [];
        actions.push({
            key: index.toString(),
            label: 'View Payroll',
            action: () => {
                handleView(item.payrollId!);
            },
            icon: {
                color: 'primary',
                name: 'visibility'
            }
        });

        return actions;
    }
    

    const columns = [
        { Header: "Payroll Name", accessor: "payrollName", id: "payrollName", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: "Payroll Type", accessor: "payrollType", id: "payrollType", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: "Payroll URL", accessor: "payrollUrl", id: "payrollUrl", Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: "Authentication Type", accessor: "authenticationType", id: "authenticationType", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: "Actions", accessor: "actions", Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];

    if (dataObject && dataObject.length > 0) {
        const rows = dataObject.map((item: ConnectedPayroll, index: number) => {
            const payrollTypeName = payrollTypes.find(p => p.id === item.payrollTypeId)?.value ?? "";
            const authTypeName = authTypes.find(a => a.id === item.authenticationTypeId)?.value ?? "";
            return {
                payrollName: item.payrollName,
                payrollType: payrollTypeName,
                payrollUrl: item.payrollUrl,
                authenticationType: authTypeName,
                actions: getActionsColumn(item, index),
            }
        });
        return { columns, rows };
    } else {
        return { columns, rows: [] };
    }
}
